import { BoxButton, ModalStickyBottomWrapper } from '@repo/ui';

export const RefundAgreementDrawerButtons = ({ label, isDisabled, onClick }: { label: string; isDisabled: boolean; onClick: () => void }) => {
  return (
    <ModalStickyBottomWrapper supportText={'경정청구서는 위 위임동의에 따라 작성 및 제출돼요.'}>
      <BoxButton size={'large'} className={'w-full'} variant={isDisabled ? 'tonal-secondary' : 'filled-primary'} onClick={onClick} disabled={isDisabled}>
        {label}
      </BoxButton>
    </ModalStickyBottomWrapper>
  );
};
